
import React, { useEffect, useState } from "react";

export default  function Loader(){
 
    return(
<>
<lottie-player src="https://assets6.lottiefiles.com/packages/lf20_lcuhab4s.json"    speed="1"  style={{width: "300px", height: "300px",background:"transparent"}}  loop  autoplay></lottie-player>
</>
    )
}


